import { GQLDestination } from '~/GqlTypes';

export default function(data: any): data is GQLDestination {
  return (
    data &&
    typeof data.__typename !== 'undefined' &&
    data.__typename === 'Destination'
  );
}
